var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { INDENT, SPACE_FILL } from "../../View";
import styled from 'styled-components';
import { STACK_ALIGN, STACK_DIRECTION, StackView } from "../../StackView";
var TabsLayoutRoot = styled(StackView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    overflow: hidden;\n    flex: 1;\n"], ["\n    position: relative;\n    overflow: hidden;\n    flex: 1;\n"])));
export function TabsLayout(_a) {
    var tabs = _a.tabs, body = _a.body;
    return (React.createElement(TabsLayoutRoot, { testId: 'tabs-layout', direction: STACK_DIRECTION.column, align: STACK_ALIGN.fill, spaceFill: SPACE_FILL.all },
        React.createElement(StackView, { spaceAll: INDENT.m, spaceBottom: INDENT.none }, tabs),
        body));
}
var templateObject_1;
//# sourceMappingURL=TabsLayout.js.map